// extracted by mini-css-extract-plugin
export var cardIcon = "hero-menu-module--card-icon--aac92";
export var cardListWrapper = "hero-menu-module--card-list-wrapper--1057b";
export var cardTitle = "hero-menu-module--card-title--d77b1";
export var cardWrapper = "hero-menu-module--card-wrapper--534ff";